import i18n from '../../translations/i18n';
import { endpoints } from '../../constants/endpoints';
import { setMessage } from './message';
import { setLogout } from './user'
import { trimLowerCase, trimUpperCase } from '../../helpers/shared';
import { handleRequest } from '../../helpers/request';
import { sendGetEndpoint } from '../../services/baseApi';
import { BASE_REQUEST_LANGUAGE } from '../types/base';
import { STATIC_DATA_SET_DATA } from '../types/staticData';
import { store } from '../store/store';

/**** Export functions  ****/
/**
 * Call to endpoint to get static-data
 * @returns
 */
export const getStaticData = (apiResponse = undefined) => async dispatch => {
  try {
    const response = apiResponse ? apiResponse : await sendGetEndpoint(endpoints.staticData);
    dispatch(handleRequest(response));
    if (!response.error) {
      delete response.error;
      delete response.status;
      if (response?.success) {
        const { actualLanguage } = store.getState().base;
        let data = {};
        data[`data_${trimLowerCase(actualLanguage)}`] = response.success;
        dispatch({ type: STATIC_DATA_SET_DATA, payload: { ...data } });
        dispatch({ type: BASE_REQUEST_LANGUAGE, payload: trimUpperCase(
          actualLanguage) });
        return true;
      } else {
        dispatch(setLogout());
        dispatch(setMessage(i18n.t("common.errorStatic"), 'error'));
        return false;
      }
    } else {
      dispatch(setLogout());
      dispatch(setMessage(i18n.t("common.errorStatic"), 'error'));
      return false;
    }
  } catch (error) {
    console.error('getStaticData: ', error);
    dispatch(setLogout());
    dispatch(setMessage(i18n.t("common.errorStatic"), 'error'));
    return false;
  }
};